(function($) {

angular.module('components.placeholder', [])

    //Workaround for IE bug - 179489
    .config(['$provide', function ($provide) {
        $provide.decorator('$sniffer', ['$delegate', function($delegate) {
            var hasEventFn = $delegate.hasEvent;

            $delegate.hasEvent = function (event) {
                // 'input' event in IE9+ has non-standard/buggy implementation, so we'll pretend the event is not supported.
                // In particular the event is fired on a textarea element when a placeholder attribute is specified, and also
                // when the input gets focus.
                if (event == 'input' && $delegate.msie >= 9 && $delegate.msie <= 11) return false;

                //call original method
                return hasEventFn.apply($delegate, arguments);
            };

            return $delegate;
        }]);
    }])

    // Shim to support placeholder attribute (watermark) for older IE browsers
    // Note: This hides watermark on focus unlike standard placeholder behavior
    .directive('placeholder', ['$timeout',
        function ($timeout) {
            if ("placeholder" in document.createElement("input")) {
                return {}; //use native support
            }

            var show = function () {
                if ($(this).val() == '') {
                    $(this)
                        .val($(this).attr('placeholder'))
                        .removeClass('ui-focus')
                        .addClass('ui-hint');
                }
            };

            var hide = function () {
                $(this)
                    .addClass('ui-focus')
                    .removeClass('ui-hint');

                if ($(this).val() == $(this).attr('placeholder')) {
                    $(this).val('');
                }
            };

            return {
                restrict: 'A',
                link: function (scope, element, attr) {

                    if (!attr.ngModel || attr.type === 'password') {
                        return;
                    }

                    scope.$watch(attr.ngModel, function (newValue) {
                        if (!newValue && !element.is(':focus')) {
                            show.apply(element);
                        }
                    });

                    $timeout(function () {
                        element.focus(hide).blur(show);

                        if ($.trim(element.val()) == '') {
                            element.val(attrs.placeholder).addClass('ui-hint');
                        }
                    });
                }
            };
        }
    ]);
})(jQuery);